import { render, staticRenderFns } from "./date-text-field.vue?vue&type=template&id=5e120b3a&"
import script from "./date-text-field.vue?vue&type=script&lang=js&"
export * from "./date-text-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports